import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi =
  ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const createQuestionnaireAgent = async ({
  creatorId,
  questionnaireTemplateId,
  agent,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(
    '/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents',
    { creatorId, questionnaireTemplateId },
  );
  const data = await formsBackendClient.post(path, { agent });
  return data.data;
};

export default createQuestionnaireAgent;
